export const HOOK_SETUP = 'devtools-plugin:setup';
export const HOOK_PLUGIN_SETTINGS_SET = 'plugin:settings:set';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@vue/devtools-api/lib/esm/const.js
// module id = null
// module chunks = 